import React, { useContext } from 'react';
import styled from 'styled-components'
import moment from 'moment'
import _ from 'lodash'
import { ResponsiveBar } from '@nivo/bar'
import { AuthContext } from '../../../../../../../auth-context'

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.

const ChartContainer = styled.div`
	// background: #FFF;
	// border-radius: 8px;
	// box-shadow: 0px 0px 8px 0px #e1e2e6;
	height: 400px;
	width: 100%;
`;

const BarChart = () => {
	const { user } = useContext(AuthContext);
	let successfulTransactionDates = {}
	user.transactions.forEach(transaction => {
		if (transaction.type === 'sale') {
			switch (transaction.status) {
				case 'submitted_for_settlement':
				case 'settling':
				case 'settled':
					if (!(transaction.createdAt in successfulTransactionDates)) {
						successfulTransactionDates[transaction.createdAt] = 0
					}
					successfulTransactionDates[transaction.createdAt] += parseFloat(transaction.amount)
					break

				default:
			}
		}
	})
	let successfulTransactions = []
	for (let td in successfulTransactionDates) {
		successfulTransactions.push({ createdAt: td, amount: successfulTransactionDates[td] })
	}
	successfulTransactions = _.takeRight(successfulTransactions, 12);

	return (
		<ChartContainer>
			<ResponsiveBar
				data={successfulTransactions}
				keys={['amount']}
				indexBy="createdAt"
				margin={{ top: 0, right: 20, bottom: 50, left: 50 }}
				padding={0.3}
				colors='#1890ff'
				axisTop={null}
				axisRight={null}
				axisBottom={{
					tickSize: 5,
					tickPadding: 5,
					tickRotation: 0,
					format: function(value) {
						return moment.utc(value).format('MMM D, YYYY')
					},
					legend: 'Date',
					legendPosition: 'middle',
					legendOffset: 32
				}}
				axisLeft={{
					tickSize: 5,
					tickPadding: 5,
					tickRotation: 0,
					legend: 'Amount',
					legendPosition: 'middle',
					legendOffset: -40
				}}
				valueFormat={value => value.toFixed(2)}
				labelSkipWidth={12}
				labelSkipHeight={12}
				labelTextColor="#FFF"
				animate={true}
				motionStiffness={90}
				motionDamping={15}
			/>
		</ChartContainer>
	)
}
export default BarChart
